var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "tool-box" }, [_c('el-dropdown', { staticClass: "tool-dropdown", attrs: { "trigger": "hover", "placement": "bottom-start" } }, [_c('span', { staticClass: "el-dropdown-link" }, [_c('svg-icon', { attrs: { "icon-class": "quick_entry", "size": 24 } })], 1), _vm._v(" "), _c('el-dropdown-menu', { attrs: { "slot": "dropdown" }, slot: "dropdown" }, _vm._l(_vm.config, function (item) {
    return _c('el-dropdown-item', { key: item.id, nativeOn: { "click": function click($event) {
          return _vm.handleMenuItem(item.pathName, item.query);
        } } }, [_vm._v(_vm._s(item.title))]);
  }), 1)], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };